import { __decorate } from "tslib";
import { _GraphQueryableCollection, _GraphQueryableInstance, graphInvokableFactory } from "../graphqueryable.js";
import { defaultPath, getById, addable, updateable } from "../decorators.js";
/**
 * Message
 */
export class _Message extends _GraphQueryableInstance {
}
export const Message = graphInvokableFactory(_Message);
/**
 * Messages
 */
let _Messages = class _Messages extends _GraphQueryableCollection {
};
_Messages = __decorate([
    defaultPath("messages"),
    getById(Message),
    addable()
], _Messages);
export { _Messages };
export const Messages = graphInvokableFactory(_Messages);
/**
 * MailFolder
 */
export class _MailFolder extends _GraphQueryableInstance {
}
export const MailFolder = graphInvokableFactory(_MailFolder);
/**
 * MailFolders
 */
let _MailFolders = class _MailFolders extends _GraphQueryableCollection {
};
_MailFolders = __decorate([
    defaultPath("mailFolders"),
    getById(MailFolder),
    addable()
], _MailFolders);
export { _MailFolders };
export const MailFolders = graphInvokableFactory(_MailFolders);
/**
 * MailboxSettings
 */
let _MailboxSettings = class _MailboxSettings extends _GraphQueryableInstance {
};
_MailboxSettings = __decorate([
    defaultPath("mailboxSettings"),
    updateable()
], _MailboxSettings);
export { _MailboxSettings };
export const MailboxSettings = graphInvokableFactory(_MailboxSettings);
//# sourceMappingURL=types.js.map